// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"511":"507339ce","690":"2fafc5bd","742":"3ea4c834"}[chunkId] + ".chunk.js";
};